import { render, staticRenderFns } from "./NoteIcon.vue?vue&type=template&id=35ddc51f&scoped=true&"
import script from "./NoteIcon.vue?vue&type=script&lang=ts&"
export * from "./NoteIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ddc51f",
  null
  
)

export default component.exports